module.exports = __webpack_public_path__ + "static/media/galleryBackgroundDesktop.a358307d.jpg";